import { Filter } from '@/common/components/FilterDrawer/FilterDrawer';
import {
  EXPERIMENTS_PARAM_DEFAULT_OWNER,
  EXPERIMENTS_PARAM_OWNER,
} from '@/common/const';
import { FilterType } from '@/common/const/filterTypes';
import { SelectType } from '@/common/const/selectTypes';
import {
  AB,
  ABORTED,
  ADAPTIVE,
  CANCELLED,
  COMPLETED,
  REQUESTED,
  SCHEDULED,
  STARTED,
} from '@/constants';

export function getExperimentFilters(tabView: string): Filter[] {
  return [
    {
      label: 'Date Range',
      name: 'dates',
      type: FilterType.DATE_RANGE,
    },
    {
      label: 'Owner',
      name:
        tabView === 'all'
          ? EXPERIMENTS_PARAM_OWNER
          : EXPERIMENTS_PARAM_DEFAULT_OWNER,
      selectType: SelectType.USER,
      placeholder: 'Select owner',
      disabled: tabView === 'my',
    },
    {
      label: 'Status',
      name: 'state',
      options: [
        { label: 'Requested', value: REQUESTED },
        { label: 'Scheduled', value: SCHEDULED },
        { label: 'Running', value: STARTED },
        { label: 'Completed', value: COMPLETED },
        { label: 'Aborted', value: ABORTED },
        { label: 'Cancelled', value: CANCELLED },
      ],
      placeholder: 'Select status',
    },
    {
      name: 'experimentType',
      label: 'Type',
      options: [
        { label: 'A/B', value: AB },
        { label: 'Adaptive', value: ADAPTIVE },
      ],
      placeholder: 'Select type',
    },
    {
      name: 'country',
      label: 'Country',
      selectType: SelectType.COUNTRY,
      placeholder: 'Select country',
    },
    {
      name: 'city',
      label: 'City',
      selectType: SelectType.CITY,
      placeholder: 'Select city',
    },
    {
      name: 'tags',
      label: 'Tags',
      selectType: SelectType.TAG,
      placeholder: 'Select tag',
    },
    {
      name: 'variable',
      label: 'Variable Included',
      selectType: SelectType.VARIABLE,
    },
    {
      name: 'overlap',
      label: 'Only show overlapping experiments',
      type: FilterType.BOOLEAN,
    },
    {
      name: 'manager',
      label: 'Product Manager',
      selectType: SelectType.USER,
      placeholder: 'Select product manager',
    },
    {
      name: 'analyst',
      label: 'Product Analyst',
      selectType: SelectType.USER,
      placeholder: 'Select product analyst',
    },
    {
      name: 'domain',
      label: 'Domain',
      selectType: SelectType.DOMAIN,
      placeholder: 'Select domain',
    },
    {
      label: 'Primary Service',
      name: 'backend',
      selectType: SelectType.BACKEND,
      placeholder: 'Select primary service',
    },
  ];
}
